import React, { useState, useEffect } from 'react';
import Lenis from 'lenis';
import { NAV_ITEMS } from './data/constants';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Highlights from './components/Highlights';
import Contact from './components/Contact';
import Footer from './components/Footer';

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState('hero');

  // Lenis smooth scroll — autoRaf lets Lenis manage its own RAF loop
  // and stop it automatically on destroy (no leaked frames)
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      autoRaf: true,
    });
    return () => lenis.destroy();
  }, []);

  // Handle hash-based scroll from project pages (e.g. /#skills)
  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) window.scrollTo({ top: el.offsetTop - 72, behavior: 'smooth' });
      }, 150);
    }
  }, []);

  // Section tracking
  useEffect(() => {
    let ticking = false;
    const handle = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const ids = ['hero', ...NAV_ITEMS.map((n) => n.id)];
        const y = window.scrollY + 120;
        for (let i = ids.length - 1; i >= 0; i--) {
          const el = document.getElementById(ids[i]);
          if (el && el.offsetTop <= y) { setActiveSection(ids[i]); break; }
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', handle, { passive: true });
    return () => window.removeEventListener('scroll', handle);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 72, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-surface text-txt font-body">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[60] focus:px-4 focus:py-2 focus:bg-green focus:text-surface focus:rounded-lg focus:text-sm focus:font-semibold">
        Skip to main content
      </a>
      <Nav navItems={NAV_ITEMS} activeSection={activeSection} onScrollTo={scrollTo} />
      <main id="main">
        <Hero onScrollTo={scrollTo} />
        <Skills />
        <Experience />
        <Projects />
        <Highlights />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Portfolio;
